import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import { getWhatsAppUrl } from '../content/site-info';

const SCROLL_THRESHOLD = 300;

function MobileStickyCta() {
  const [isVisible, setIsVisible] = useState(false);
  const location = useLocation();
  const formHref = location.pathname === '/'
    ? '#formularios-combinados'
    : '/#formularios-combinados';

  useEffect(() => {
    function handleScroll() {
      setIsVisible(window.scrollY > SCROLL_THRESHOLD);
    }

    handleScroll();
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    document.documentElement.classList.toggle('sticky-cta-visible', isVisible);
    return () => document.documentElement.classList.remove('sticky-cta-visible');
  }, [isVisible]);

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          initial={{ y: 80, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 80, opacity: 0 }}
          transition={{ duration: 0.25, ease: 'easeOut' }}
          className="fixed inset-x-0 bottom-0 z-40 md:hidden pointer-events-none"
          role="region"
          aria-label="Ações rápidas"
        >
          <div
            className="pointer-events-auto border-t border-gray-200/80 dark:border-gray-700/80 
                       bg-white/95 dark:bg-gray-900/95 backdrop-blur-md shadow-[0_-4px_20px_rgba(0,0,0,0.08)] 
                       px-3 py-2.5 pb-[max(0.625rem,env(safe-area-inset-bottom))]"
          >
            <div className="flex gap-2 max-w-lg mx-auto">
              <a
                href={formHref}
                className="btn-primary flex-1 text-sm py-2.5 min-h-11 inline-flex items-center justify-center"
              >
                Orçamento grátis
              </a>
              <a
                href={getWhatsAppUrl('Olá! Quero solicitar um orçamento.')}
                target="_blank"
                rel="noopener noreferrer"
                className="btn-secondary flex-1 text-sm py-2.5 min-h-11 inline-flex items-center justify-center 
                         dark:border-primary-500 dark:text-primary-300 dark:hover:bg-primary-950"
              >
                WhatsApp
              </a>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}

export default MobileStickyCta;
